export default {
  root: '/',
  requestCode: '/request-code',
  submitCode: '/submit-code',
  ssoRedirect: '/sso-redirect',
  oauthSignIn: '/oauth/sign-in',
  oauthAuthorize: '/oauth/authorize'
};
